module.exports = __webpack_public_path__ + "9e34d3aa2333476dd9fdf8f6e605a1e7.png";